<template>
  <topbar
    :titulo="$t('FINANCEIRO.BANCOS')"
    :subtitulo="$t('FINANCEIRO.BANCOS_DESCRICAO')"
    :breadcrumbs="breadcrumbs"
  >
    <template #header>
      <div class="d-flex justify-content-between ml-md-4 gap-1">
        <div></div>
        <b-button variant="info" @click="cadastrar" v-if="podeCadastrar">
          {{ $t('GERAL.CADASTRAR') }}
        </b-button>
      </div>
    </template>
  </topbar>
</template>
<script>
// Utils & Aux:
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import Permissoes from '@/components/mixins/permissoes';

export default {
  mixins: [Permissoes],
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: 'FINANCEIRO.FINANCEIRO' },
        { titulo: 'FINANCEIRO.BANCOS' },
      ],
    };
  },
  methods: {
    // FUNÇÕES AUXILIARES:
    cadastrar() {
      this.$emit('cadastrar', 'banco');
    },
  },
};
</script>
